
export const toIntOrDefault = (value, defaultValue = 0) => {
    const intValue = parseInt(value);
    return isNaN(intValue) ? defaultValue : intValue;
};


 